// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2z-KZ","textStatus":"styles_textStatus__Xu70l"};